import { render, staticRenderFns } from "./AddNotes.vue?vue&type=template&id=3b551374&scoped=true&"
import script from "./AddNotes.vue?vue&type=script&lang=js&"
export * from "./AddNotes.vue?vue&type=script&lang=js&"
import style0 from "./AddNotes.vue?vue&type=style&index=0&id=3b551374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b551374",
  null
  
)

export default component.exports